async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return data;
}

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value != null && value !== "") search.set(key, String(value));
  }
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchVehicleDataQualityOverview(params = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-data-quality/overview${buildQuery(params)}`
  );
}

export async function fetchVehicleDataQualityIssues(params = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-data-quality/issues${buildQuery(params)}`
  );
}

export async function fetchVehicleDataQualityIssue(id) {
  return requestJson(
    `/api/admin/mobility/vehicle-data-quality/issues/${encodeURIComponent(id)}`
  );
}

export async function patchVehicleDataQualityIssue(id, body) {
  return requestJson(
    `/api/admin/mobility/vehicle-data-quality/issues/${encodeURIComponent(id)}`,
    { method: "PATCH", body: JSON.stringify(body) }
  );
}

export async function fetchVehicleListingDataQuality(listingId) {
  return requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/data-quality`
  );
}

export async function recalculateVehicleListingQuality(listingId) {
  return requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/recalculate-quality`,
    { method: "POST" }
  );
}

export async function recalculateVehicleSourceQuality(sourceId, params = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-sources/${encodeURIComponent(sourceId)}/recalculate-quality${buildQuery(params)}`,
    { method: "POST" }
  );
}

export async function recalculateAllVehicleDataQuality(params = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-data-quality/recalculate${buildQuery(params)}`,
    { method: "POST" }
  );
}
